import React from "react";
import { FaUserMd, FaRegAddressCard, FaCalendarCheck } from "react-icons/fa";
import { motion } from "framer-motion";

const Whychoseus = () => {
  const features = [
    {
      icon: <FaUserMd />,
      title: "Top Specialists",
      desc: "Consult the best doctors with verified credentials and trusted experience.",
    },
    {
      icon: <FaRegAddressCard />,
      title: "Seamless Access",
      desc: "Book appointments and connect from anywhere, anytime with ease.",
    },
    {
      icon: <FaCalendarCheck />,
      title: "Instant Booking",
      desc: "Forget long queues — schedule your visit with just one tap.",
    },
  ];

  const sectionStyle = {
    padding: "100px 20px",
    background: "radial-gradient(circle at 50% 20%, #e7f2ff 0%, #ffffff 70%)",
    position: "relative",
    textAlign: "center",
    fontFamily: "'Poppins', sans-serif",
  };

  const waveStyle = {
    content: '""',
    position: "absolute",
    bottom: "-80px",
    left: "0",
    width: "100%",
    height: "300px",
    background: "radial-gradient(circle at 50% -80px, #007bff 0%, transparent 70%)",
    opacity: "0.25",
  };

  const headingStyle = {
    fontSize: "42px",
    fontWeight: "800",
    color: "#0b1c39",
    marginBottom: "15px",
  };

  const subTextStyle = {
    color: "#555",
    fontSize: "18px",
    marginBottom: "70px",
    lineHeight: 1.8,
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "40px",
    position: "relative",
    zIndex: 2,
  };

  const featureStyle = {
    flex: "1 1 300px",
    maxWidth: "360px",
    padding: "30px 25px",
    backdropFilter: "blur(12px)",
    background: "#09bbaf",
    borderRadius: "20px",
    border: "1px solid rgba(0, 123, 255, 0.2)",
    transition: "transform 0.4s ease, box-shadow 0.4s ease",
    cursor: "default",
  };

  const iconWrapper = {
    width: "90px",
    height: "90px",
    margin: "0 auto 25px",
    background: "#ffcb24",
    border: "2px solid #ffcb24",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "42px",
    color: "#0b1c39",
    boxShadow: "0 0 25px rgba(0, 123, 255, 0.3)",
    transform: "rotate(-8deg)",
    transition: "all 0.4s ease",
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "700",
    color: "#0b1c39",
    marginBottom: "12px",
  };

  const descStyle = {
    fontSize: "17px",
    color: "#444",
    lineHeight: "1.8",
  };

  return (
    <section style={sectionStyle}>
      <div style={waveStyle}></div>
      <h2 style={headingStyle}>
        Why <span style={{ color: "#ffcb24" }}>Choose Us ?</span>
      </h2>
      <p style={subTextStyle}>
        A new way to experience healthcare — simple, smart, and secure.
      </p>

      <div style={containerStyle}>
        {features.map((item, i) => (
          <motion.div
            key={i}
            style={featureStyle}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 10px 30px rgba(0, 123, 255, 0.2)",
            }}
            transition={{ duration: 0.4 }}
            viewport={{ once: true }}
          >
            <motion.div
              style={iconWrapper}
              whileHover={{ rotate: 10, scale: 1.1 }}
              transition={{ type: "spring", stiffness: 250 }}
            >
              {item.icon}
            </motion.div>
            <h3 style={titleStyle}>{item.title}</h3>
            <p style={descStyle}>{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Whychoseus;
